import React, { useState, createContext } from 'react';

export const AppContext = createContext();

export function AppProvider({ children }) {
  const settings = JSON.parse(localStorage.getItem('settings'));

  const [snack, setSnack] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [darkTheme, setDarkTheme] = useState(
    settings ? settings.darkMode : false
  );
  const [sidebar, setSidebar] = useState(false);

  return (
    <AppContext.Provider
      value={{
        snack: [snack, setSnack],
        isLoading: [isLoading, setIsLoading],
        darkTheme: [darkTheme, setDarkTheme],
        sidebar: [sidebar, setSidebar],
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
